// 模板互動Demo JavaScript
class TemplateDemo {
  constructor() {
    this.currentConfig = {
      template: 't1',
      mode: 'w',
      color: 'red',
      device: 'desktop',
      page: 'index'
    };
    
    // 動態檢測的可用組合 - 會自動檢測圖片檔案存在狀態
    // 結構：template -> mode -> device -> [colors]
    this.availableCombinations = {};
    
    // 定義所有可能的組合來進行檢測
    this.allPossibleCombinations = {
      templates: ['t1', 't2'], // 可以擴展更多模板
      modes: ['w', 'd'],
      colors: ['red', 'yellow', 'blue', 'green', 'purple', 'orange'],
      devices: ['desktop', 'mobile'],
      pages: ['index'] // 目前主要是index頁面
    };
    
    // 檢測狀態
    this.detectionComplete = false;
    
    this.init();
  }

  init() {
    this.showLoadingState();
    this.bindEvents();
    this.detectAvailableCombinations().then(() => {
      this.hideLoadingState();
      this.updateAvailableOptions();
      this.updatePreview();
    });
  }

  // 顯示載入狀態
  showLoadingState() {
    const controls = document.querySelector('.demo-controls');
    if (!controls) return;

    // 隱藏所有控制組和可用性資訊
    const controlGroups = controls.querySelectorAll('.control-group');
    controlGroups.forEach(group => {
      group.style.display = 'none';
    });

    const availabilityInfo = controls.querySelector('.availability-info');
    if (availabilityInfo) {
      availabilityInfo.style.display = 'none';
    }

    // 創建或顯示載入提示
    let loadingElement = controls.querySelector('.loading-state');
    if (!loadingElement) {
      loadingElement = document.createElement('div');
      loadingElement.className = 'loading-state';
      loadingElement.innerHTML = `
        <div class="loading-content">
          <div class="loading-spinner"></div>
          <p>正在載入模板選項...</p>
          <small>請稍候</small>
        </div>
      `;
      controls.insertBefore(loadingElement, controls.firstChild);
    }
    loadingElement.style.display = 'block';
  }

  // 隱藏載入狀態
  hideLoadingState() {
    const controls = document.querySelector('.demo-controls');
    if (!controls) return;

    // 顯示所有控制組
    const controlGroups = controls.querySelectorAll('.control-group');
    controlGroups.forEach(group => {
      group.style.display = '';
    });

    // 顯示可用性資訊
    const availabilityInfo = controls.querySelector('.availability-info');
    if (availabilityInfo) {
      availabilityInfo.style.display = '';
    }

    // 隱藏載入提示
    const loadingElement = controls.querySelector('.loading-state');
    if (loadingElement) {
      loadingElement.style.display = 'none';
    }
  }

  bindEvents() {
    // 模板選擇
    document.querySelectorAll('.template-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (e.target.disabled) return;
        
        this.setActiveButton('.template-btn', e.target);
        this.currentConfig.template = e.target.dataset.template;
        this.autoSelectValidOptions();
        this.updateAvailableOptions();
        this.updatePreview();
      });
    });

    // 模式選擇
    document.querySelectorAll('.mode-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (e.target.disabled) return;
        
        this.setActiveButton('.mode-btn', e.target);
        this.currentConfig.mode = e.target.dataset.mode;
        this.autoSelectValidDevice();
        this.autoSelectValidColor();
        this.updateAvailableOptions();
        this.updatePreview();
      });
    });

    // 顏色選擇
    document.querySelectorAll('.color-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (e.target.disabled) return;
        
        this.setActiveButton('.color-btn', e.target);
        this.currentConfig.color = e.target.dataset.color;
        this.updatePreview();
      });
    });

    // 設備選擇
    document.querySelectorAll('.device-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (e.target.disabled) return;
        
        this.setActiveButton('.device-btn', e.target);
        this.currentConfig.device = e.target.dataset.device;
        this.autoSelectValidColor();
        this.updateAvailableOptions();
        this.updatePreview();
      });
    });
  }

  setActiveButton(selector, activeBtn) {
    if (!activeBtn) return;
    
    document.querySelectorAll(selector).forEach(btn => {
      btn.classList.remove('active');
    });
    
    if (!activeBtn.disabled) {
      activeBtn.classList.add('active');
    }
  }

  // 動態檢測所有可用的組合
  async detectAvailableCombinations() {
    console.log('開始檢測可用的模板組合...');
    const { templates, modes, colors, devices, pages } = this.allPossibleCombinations;
    const detectionPromises = [];
    
    // 重置可用組合
    this.availableCombinations = {};
    
    // 為每個可能的組合創建檢測Promise
    templates.forEach(template => {
      modes.forEach(mode => {
        devices.forEach(device => {
          colors.forEach(color => {
            pages.forEach(page => {
              const promise = this.checkImageExists(template, mode, color, device, page);
              detectionPromises.push(promise);
            });
          });
        });
      });
    });
    
    // 等待所有檢測完成
    const results = await Promise.all(detectionPromises);
    
    // 處理檢測結果
    results.forEach(result => {
      if (result.exists) {
        const { template, mode, device, color } = result;
        
        // 初始化結構
        if (!this.availableCombinations[template]) {
          this.availableCombinations[template] = {};
        }
        if (!this.availableCombinations[template][mode]) {
          this.availableCombinations[template][mode] = {};
        }
        if (!this.availableCombinations[template][mode][device]) {
          this.availableCombinations[template][mode][device] = [];
        }
        
        // 添加可用顏色
        if (!this.availableCombinations[template][mode][device].includes(color)) {
          this.availableCombinations[template][mode][device].push(color);
        }
      }
    });
    
    this.detectionComplete = true;
    console.log('檢測完成！可用組合：', this.availableCombinations);
    
    // 更新模板按鈕顯示
    this.updateTemplateButtons();
    
    // 自動選擇有效配置
    this.autoSelectValidOptions();
  }

  // 檢查單個圖片是否存在
  checkImageExists(template, mode, color, device, page) {
    return new Promise((resolve) => {
      const imagePath = `templates/${page}/${template}-${mode}-${color}-${device}-${page}.jpg`;
      const img = new Image();
      
      img.onload = () => {
        resolve({
          template, mode, color, device, page,
          exists: true,
          path: imagePath
        });
      };
      
      img.onerror = () => {
        resolve({
          template, mode, color, device, page,
          exists: false,
          path: imagePath
        });
      };
      
      // 設置超時
      setTimeout(() => {
        resolve({
          template, mode, color, device, page,
          exists: false,
          path: imagePath
        });
      }, 3000);
      
      img.src = `/assets/${imagePath}`;
    });
  }

  // 更新模板按鈕顯示
  updateTemplateButtons() {
    const templateSelector = document.querySelector('.template-selector');
    if (!templateSelector) return;
    
    // 清空現有按鈕
    templateSelector.innerHTML = '';
    
    // 為每個有可用組合的模板創建按鈕
    Object.keys(this.availableCombinations).sort().forEach((template, index) => {
      const templateNumber = template.replace('t', '');
      const btn = document.createElement('button');
      btn.className = 'template-btn';
      btn.dataset.template = template;
      btn.textContent = `模板 ${templateNumber}`;
      
      // 如果是第一個模板，設為active
      if (index === 0) {
        btn.classList.add('active');
        this.currentConfig.template = template;
      }
      
      btn.addEventListener('click', (e) => {
        if (e.target.disabled) return;
        
        this.setActiveButton('.template-btn', e.target);
        this.currentConfig.template = e.target.dataset.template;
        this.autoSelectValidOptions();
        this.updateAvailableOptions();
        this.updatePreview();
      });
      
      templateSelector.appendChild(btn);
    });
  }

  // 檢查特定組合是否可用
  isCombinatonAvailable(template, mode, device, color) {
    return this.availableCombinations[template] && 
           this.availableCombinations[template][mode] && 
           this.availableCombinations[template][mode][device] &&
           this.availableCombinations[template][mode][device].includes(color);
  }

  // 獲取模板可用的模式
  getAvailableModes(template) {
    if (!this.availableCombinations[template]) return [];
    return Object.keys(this.availableCombinations[template]);
  }

  // 獲取模板和模式下可用的設備
  getAvailableDevices(template, mode) {
    if (!this.availableCombinations[template] || !this.availableCombinations[template][mode]) {
      return [];
    }
    return Object.keys(this.availableCombinations[template][mode]);
  }

  // 獲取模板、模式和設備下可用的顏色
  getAvailableColors(template, mode, device) {
    if (!this.availableCombinations[template] || 
        !this.availableCombinations[template][mode] ||
        !this.availableCombinations[template][mode][device]) {
      return [];
    }
    return this.availableCombinations[template][mode][device];
  }

  // 自動選擇有效的選項
  autoSelectValidOptions() {
    const template = this.currentConfig.template;
    const availableModes = this.getAvailableModes(template);
    
    // 如果當前模式不可用，選擇第一個可用的模式
    if (!availableModes.includes(this.currentConfig.mode)) {
      this.currentConfig.mode = availableModes[0] || 'w';
      this.setActiveButton('.mode-btn', document.querySelector(`[data-mode="${this.currentConfig.mode}"]`));
    }
    
    this.autoSelectValidDevice();
    this.autoSelectValidColor();
  }

  // 自動選擇有效的設備
  autoSelectValidDevice() {
    const { template, mode } = this.currentConfig;
    const availableDevices = this.getAvailableDevices(template, mode);
    
    // 如果當前設備不可用，選擇第一個可用的設備
    if (!availableDevices.includes(this.currentConfig.device)) {
      this.currentConfig.device = availableDevices[0] || 'desktop';
      this.setActiveButton('.device-btn', document.querySelector(`[data-device="${this.currentConfig.device}"]`));
    }
  }

  // 自動選擇有效的顏色
  autoSelectValidColor() {
    const { template, mode, device } = this.currentConfig;
    const availableColors = this.getAvailableColors(template, mode, device);
    
    // 如果當前顏色不可用，選擇第一個可用的顏色
    if (!availableColors.includes(this.currentConfig.color)) {
      this.currentConfig.color = availableColors[0] || 'red';
      this.setActiveButton('.color-btn', document.querySelector(`[data-color="${this.currentConfig.color}"]`));
    }
  }

  // 更新可用選項的狀態
  updateAvailableOptions() {
    if (!this.detectionComplete) return;
    
    const { template, mode, device } = this.currentConfig;
    const availableModes = this.getAvailableModes(template);
    const availableDevices = this.getAvailableDevices(template, mode);
    const availableColors = this.getAvailableColors(template, mode, device);

    // 更新模式按鈕狀態
    document.querySelectorAll('.mode-btn').forEach(btn => {
      const btnMode = btn.dataset.mode;
      const isAvailable = availableModes.includes(btnMode);
      
      btn.disabled = !isAvailable;
      if (!isAvailable) {
        btn.classList.remove('active');
      }
    });

    // 更新設備按鈕狀態
    document.querySelectorAll('.device-btn').forEach(btn => {
      const btnDevice = btn.dataset.device;
      const isAvailable = availableDevices.includes(btnDevice);
      
      btn.disabled = !isAvailable;
      if (!isAvailable) {
        btn.classList.remove('active');
      }
    });

    // 更新顏色按鈕狀態
    let hasActiveColor = false;
    document.querySelectorAll('.color-btn').forEach(btn => {
      const btnColor = btn.dataset.color;
      const isAvailable = availableColors.includes(btnColor);
      
      btn.disabled = !isAvailable;
      if (!isAvailable) {
        btn.classList.remove('active');
      } else if (btnColor === this.currentConfig.color) {
        // 如果當前顏色可用，確保它是active的
        btn.classList.add('active');
        hasActiveColor = true;
      }
    });

    // 如果當前選中的顏色不可用，自動選擇第一個可用的顏色
    if (!hasActiveColor && availableColors.length > 0) {
      this.currentConfig.color = availableColors[0];
      const firstAvailableBtn = document.querySelector(`[data-color="${this.currentConfig.color}"]`);
      if (firstAvailableBtn && !firstAvailableBtn.disabled) {
        this.setActiveButton('.color-btn', firstAvailableBtn);
      }
    }

    // 更新可用組合提示
    this.updateAvailabilityInfo();
  }

  // 更新可用性資訊顯示
  updateAvailabilityInfo() {
    const { template } = this.currentConfig;
    const availableModes = this.getAvailableModes(template);
    const infoElement = document.getElementById('available-combinations');
    
    if (!infoElement) return;

    if (!this.detectionComplete) {
      infoElement.textContent = '正在檢測可用組合...';
      return;
    }

    let infoText = '';
    if (availableModes.length === 0) {
      infoText = '此模板暫無可用配置';
    } else {
      const configTexts = [];
      availableModes.forEach(mode => {
        const devices = this.getAvailableDevices(template, mode);
        const modeText = mode === 'w' ? '淺色' : '深色';
        
        devices.forEach(device => {
          const colors = this.getAvailableColors(template, mode, device);
          const deviceText = device === 'desktop' ? '桌面版' : '手機版';
          const colorTexts = colors.map(color => this.getColorText(color)).join('、');
          configTexts.push(`${modeText}-${deviceText}(${colorTexts})`);
        });
      });
      infoText = `可用配置：${configTexts.join('；')}`;
    }
    
    infoElement.textContent = infoText;
  }

  generateImagePath() {
    const { template, mode, color, device, page } = this.currentConfig;
    return `templates/${page}/${template}-${mode}-${color}-${device}-${page}.jpg`;
  }

  updatePreview() {
    const imagePath = this.generateImagePath();
    const previewImage = document.getElementById('preview-image');
    const noImageMessage = document.getElementById('no-image-message');
    const configText = document.getElementById('current-config-text');
    const expectedFilename = document.getElementById('expected-filename');

    // 更新配置文字
    const modeText = this.currentConfig.mode === 'w' ? '淺色' : '深色';
    const colorText = this.getColorText(this.currentConfig.color);
    const deviceText = this.currentConfig.device === 'desktop' ? '桌面版' : '手機版';
    const templateText = `模板${this.currentConfig.template.replace('t', '')}`;
    
    configText.textContent = `${templateText} - ${modeText} - ${colorText} - ${deviceText}`;
    expectedFilename.textContent = `${this.currentConfig.template}-${this.currentConfig.mode}-${this.currentConfig.color}-${this.currentConfig.device}-${this.currentConfig.page}.jpg`;

    // 添加載入效果
    previewImage.classList.add('loading');

    // 創建新的圖片元素來測試是否存在
    const testImage = new Image();
    
    testImage.onload = () => {
      // 圖片存在，顯示圖片
      previewImage.src = `/assets/${imagePath}`;
      previewImage.style.display = 'block';
      previewImage.classList.remove('loading');
      previewImage.classList.add('loaded');
      noImageMessage.style.display = 'none';
      
      // 移除載入完成的class
      setTimeout(() => {
        previewImage.classList.remove('loaded');
      }, 500);
    };
    
    testImage.onerror = () => {
      // 圖片不存在，顯示錯誤訊息
      previewImage.style.display = 'none';
      previewImage.classList.remove('loading');
      noImageMessage.style.display = 'block';
    };
    
    // 開始載入測試
    testImage.src = `/assets/${imagePath}`;
  }

  getColorText(color) {
    const colorMap = {
      'red': '紅色',
      'yellow': '黃色',
      'blue': '藍色',
      'green': '綠色',
      'purple': '紫色',
      'orange': '橘色'
    };
    return colorMap[color] || color;
  }

  // 公開方法：添加新模板
  addTemplate(templateId, templateName) {
    const templateSelector = document.querySelector('.template-selector');
    const newBtn = document.createElement('button');
    newBtn.className = 'template-btn';
    newBtn.dataset.template = templateId;
    newBtn.textContent = templateName;
    
    newBtn.addEventListener('click', (e) => {
      this.setActiveButton('.template-btn', e.target);
      this.currentConfig.template = e.target.dataset.template;
      this.updatePreview();
    });
    
    templateSelector.appendChild(newBtn);
  }

  // 公開方法：添加新顏色
  addColor(colorId, colorName, colorHex) {
    const colorSelector = document.querySelector('.color-selector');
    const newBtn = document.createElement('button');
    newBtn.className = 'color-btn';
    newBtn.dataset.color = colorId;
    newBtn.textContent = colorName;
    newBtn.style.backgroundColor = colorHex;
    
    newBtn.addEventListener('click', (e) => {
      this.setActiveButton('.color-btn', e.target);
      this.currentConfig.color = e.target.dataset.color;
      this.updatePreview();
    });
    
    colorSelector.appendChild(newBtn);
  }

  // 公開方法：設置當前配置
  setConfig(config) {
    this.currentConfig = { ...this.currentConfig, ...config };
    
    // 檢查並自動調整無效的配置
    this.autoSelectValidOptions();
    
    // 更新按鈕狀態
    if (config.template) {
      this.setActiveButton('.template-btn', document.querySelector(`[data-template="${this.currentConfig.template}"]`));
    }
    if (config.mode) {
      this.setActiveButton('.mode-btn', document.querySelector(`[data-mode="${this.currentConfig.mode}"]`));
    }
    if (config.color) {
      this.setActiveButton('.color-btn', document.querySelector(`[data-color="${this.currentConfig.color}"]`));
    }
    if (config.device) {
      this.setActiveButton('.device-btn', document.querySelector(`[data-device="${this.currentConfig.device}"]`));
    }
    
    this.updateAvailableOptions();
    this.updatePreview();
  }

  // 公開方法：更新可用組合配置
  updateAvailableCombinations(combinations) {
    this.availableCombinations = { ...this.availableCombinations, ...combinations };
    this.autoSelectValidOptions();
    this.updateAvailableOptions();
    this.updatePreview();
  }
}

// 當DOM載入完成後初始化
document.addEventListener('DOMContentLoaded', function() {
  // 檢查是否存在模板demo區域
  if (document.querySelector('.template-demo-section')) {
    window.templateDemo = new TemplateDemo();
  }
});
